export interface Spacing {
    unit: number;
    units: (...units: number[]) => string;
}

function unitToPixels(unit: number, value: number) {
    return `${unit * value}px`;
}

export function createSpacing(props: Partial<Spacing> = {}): Spacing {
    const {unit = 10, ...other} = props;

    return {
        unit,
        units: (...units: number[]) => {
            if (units.length === 1) {
                return unitToPixels(unit, units[0]);
            }

            return units.map(value => unitToPixels(unit, value)).join(' ');
        },
        ...other
    };
}
